/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: p4wVBWq4E6w_
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebButtonAppWindow from "../../OP1WebButtonAppWindow"; // plasmic-import: BXxrqEh84nVD/codeComponent
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebHomepage.module.css"; // plasmic-import: p4wVBWq4E6w_/css
import smileyM4MOry9Rs5Jp from "./images/smiley.svg"; // plasmic-import: M4mOry9rs5Jp/picture
import smiley25N8XEkRVuXc from "./images/smiley2.svg"; // plasmic-import: 5n8xEk-RVuXc/picture
import smiley3Gd3RD7GUz0E from "./images/smiley3.svg"; // plasmic-import: Gd3rD7gUZ_0E/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicOp1WebHomepage__VariantProps = new Array();

export const PlasmicOp1WebHomepage__ArgProps = new Array();

const $$ = {};

function PlasmicOp1WebHomepage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appWindowButton.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_nJ1Nn58LcfAm7wemZm71QH",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <div
          data-plasmic-name={"workspaceContentWrapper"}
          data-plasmic-override={overrides.workspaceContentWrapper}
          className={classNames("all", sty.workspaceContentWrapper)}
        >
          <div
            data-plasmic-name={"frame530"}
            data-plasmic-override={overrides.frame530}
            className={classNames("all", sty.frame530)}
          >
            <div
              data-plasmic-name={"communityMemberAvartar"}
              data-plasmic-override={overrides.communityMemberAvartar}
              className={classNames("all", sty.communityMemberAvartar)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__tIpGn)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar2"}
              data-plasmic-override={overrides.communityMemberAvartar2}
              className={classNames("all", sty.communityMemberAvartar2)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__qmM5X)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar3"}
              data-plasmic-override={overrides.communityMemberAvartar3}
              className={classNames("all", sty.communityMemberAvartar3)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__z63Oe)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar4"}
              data-plasmic-override={overrides.communityMemberAvartar4}
              className={classNames("all", sty.communityMemberAvartar4)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__qb4NT)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar5"}
              data-plasmic-override={overrides.communityMemberAvartar5}
              className={classNames("all", sty.communityMemberAvartar5)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__dnetw)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar6"}
              data-plasmic-override={overrides.communityMemberAvartar6}
              className={classNames("all", sty.communityMemberAvartar6)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___2U5CI)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar7"}
              data-plasmic-override={overrides.communityMemberAvartar7}
              className={classNames("all", sty.communityMemberAvartar7)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__eqdna)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar8"}
              data-plasmic-override={overrides.communityMemberAvartar8}
              className={classNames("all", sty.communityMemberAvartar8)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__xcfpy)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar9"}
              data-plasmic-override={overrides.communityMemberAvartar9}
              className={classNames("all", sty.communityMemberAvartar9)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__hPQgO)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar10"}
              data-plasmic-override={overrides.communityMemberAvartar10}
              className={classNames("all", sty.communityMemberAvartar10)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__pPrtO)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar11"}
              data-plasmic-override={overrides.communityMemberAvartar11}
              className={classNames("all", sty.communityMemberAvartar11)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__o1Far)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar12"}
              data-plasmic-override={overrides.communityMemberAvartar12}
              className={classNames("all", sty.communityMemberAvartar12)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__nqOvj)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar13"}
              data-plasmic-override={overrides.communityMemberAvartar13}
              className={classNames("all", sty.communityMemberAvartar13)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___7N1Lp)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar14"}
              data-plasmic-override={overrides.communityMemberAvartar14}
              className={classNames("all", sty.communityMemberAvartar14)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__o1ZO)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar15"}
              data-plasmic-override={overrides.communityMemberAvartar15}
              className={classNames("all", sty.communityMemberAvartar15)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___0RUfV)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar16"}
              data-plasmic-override={overrides.communityMemberAvartar16}
              className={classNames("all", sty.communityMemberAvartar16)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__xE2C0)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar17"}
              data-plasmic-override={overrides.communityMemberAvartar17}
              className={classNames("all", sty.communityMemberAvartar17)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__rbGe2)}
                displayHeight={"79.99999237060547px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"79.99999237060547px"}
                loading={"lazy"}
                src={{
                  src: smiley25N8XEkRVuXc,
                  fullWidth: 79.99999237060547,
                  fullHeight: 79.99999237060547,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar18"}
              data-plasmic-override={overrides.communityMemberAvartar18}
              className={classNames("all", sty.communityMemberAvartar18)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__uem1Q)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar19"}
              data-plasmic-override={overrides.communityMemberAvartar19}
              className={classNames("all", sty.communityMemberAvartar19)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__etxUa)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar20"}
              data-plasmic-override={overrides.communityMemberAvartar20}
              className={classNames("all", sty.communityMemberAvartar20)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__u6Nv)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar21"}
              data-plasmic-override={overrides.communityMemberAvartar21}
              className={classNames("all", sty.communityMemberAvartar21)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__hyh)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar22"}
              data-plasmic-override={overrides.communityMemberAvartar22}
              className={classNames("all", sty.communityMemberAvartar22)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__kkNag)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar23"}
              data-plasmic-override={overrides.communityMemberAvartar23}
              className={classNames("all", sty.communityMemberAvartar23)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__xSvCj)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar24"}
              data-plasmic-override={overrides.communityMemberAvartar24}
              className={classNames("all", sty.communityMemberAvartar24)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__pP7Ll)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar25"}
              data-plasmic-override={overrides.communityMemberAvartar25}
              className={classNames("all", sty.communityMemberAvartar25)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___6Kahj)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar26"}
              data-plasmic-override={overrides.communityMemberAvartar26}
              className={classNames("all", sty.communityMemberAvartar26)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__b5Xf)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar27"}
              data-plasmic-override={overrides.communityMemberAvartar27}
              className={classNames("all", sty.communityMemberAvartar27)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___9PTog)}
                displayHeight={"64px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"64px"}
                loading={"lazy"}
                src={{
                  src: smileyM4MOry9Rs5Jp,
                  fullWidth: 64,
                  fullHeight: 64,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar28"}
              data-plasmic-override={overrides.communityMemberAvartar28}
              className={classNames("all", sty.communityMemberAvartar28)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__hooCd)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar29"}
              data-plasmic-override={overrides.communityMemberAvartar29}
              className={classNames("all", sty.communityMemberAvartar29)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__k5Vip)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar30"}
              data-plasmic-override={overrides.communityMemberAvartar30}
              className={classNames("all", sty.communityMemberAvartar30)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___8LyC5)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <div
              data-plasmic-name={"communityMemberAvartar31"}
              data-plasmic-override={overrides.communityMemberAvartar31}
              className={classNames("all", sty.communityMemberAvartar31)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img___5NXd1)}
                displayHeight={"56.000003814697266px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"56px"}
                loading={"lazy"}
                src={{
                  src: smiley3Gd3RD7GUz0E,
                  fullWidth: 56,
                  fullHeight: 56.000003814697266,
                  aspectRatio: undefined
                }}
              />
            </div>
            <Op1WebButtonAppWindow
              data-plasmic-name={"appWindowButton"}
              data-plasmic-override={overrides.appWindowButton}
              className={classNames("__wab_instance", sty.appWindowButton)}
              onFocusedChange={async (...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "appWindowButton",
                  "isFocused"
                ]).apply(null, eventArgs);
              }}
              onOpenChange={async (...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "appWindowButton",
                  "isOpen"
                ]).apply(null, eventArgs);
              }}
              onStateChange={async (...eventArgs) => {
                generateStateOnChangeProp($state, [
                  "appWindowButton",
                  "state"
                ]).apply(null, eventArgs);
              }}
              windowId={"textTest"}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "workspaceContentWrapper",
    "frame530",
    "communityMemberAvartar",
    "communityMemberAvartar2",
    "communityMemberAvartar3",
    "communityMemberAvartar4",
    "communityMemberAvartar5",
    "communityMemberAvartar6",
    "communityMemberAvartar7",
    "communityMemberAvartar8",
    "communityMemberAvartar9",
    "communityMemberAvartar10",
    "communityMemberAvartar11",
    "communityMemberAvartar12",
    "communityMemberAvartar13",
    "communityMemberAvartar14",
    "communityMemberAvartar15",
    "communityMemberAvartar16",
    "communityMemberAvartar17",
    "communityMemberAvartar18",
    "communityMemberAvartar19",
    "communityMemberAvartar20",
    "communityMemberAvartar21",
    "communityMemberAvartar22",
    "communityMemberAvartar23",
    "communityMemberAvartar24",
    "communityMemberAvartar25",
    "communityMemberAvartar26",
    "communityMemberAvartar27",
    "communityMemberAvartar28",
    "communityMemberAvartar29",
    "communityMemberAvartar30",
    "communityMemberAvartar31",
    "appWindowButton"
  ],

  workspaceContentWrapper: [
    "workspaceContentWrapper",
    "frame530",
    "communityMemberAvartar",
    "communityMemberAvartar2",
    "communityMemberAvartar3",
    "communityMemberAvartar4",
    "communityMemberAvartar5",
    "communityMemberAvartar6",
    "communityMemberAvartar7",
    "communityMemberAvartar8",
    "communityMemberAvartar9",
    "communityMemberAvartar10",
    "communityMemberAvartar11",
    "communityMemberAvartar12",
    "communityMemberAvartar13",
    "communityMemberAvartar14",
    "communityMemberAvartar15",
    "communityMemberAvartar16",
    "communityMemberAvartar17",
    "communityMemberAvartar18",
    "communityMemberAvartar19",
    "communityMemberAvartar20",
    "communityMemberAvartar21",
    "communityMemberAvartar22",
    "communityMemberAvartar23",
    "communityMemberAvartar24",
    "communityMemberAvartar25",
    "communityMemberAvartar26",
    "communityMemberAvartar27",
    "communityMemberAvartar28",
    "communityMemberAvartar29",
    "communityMemberAvartar30",
    "communityMemberAvartar31",
    "appWindowButton"
  ],

  frame530: [
    "frame530",
    "communityMemberAvartar",
    "communityMemberAvartar2",
    "communityMemberAvartar3",
    "communityMemberAvartar4",
    "communityMemberAvartar5",
    "communityMemberAvartar6",
    "communityMemberAvartar7",
    "communityMemberAvartar8",
    "communityMemberAvartar9",
    "communityMemberAvartar10",
    "communityMemberAvartar11",
    "communityMemberAvartar12",
    "communityMemberAvartar13",
    "communityMemberAvartar14",
    "communityMemberAvartar15",
    "communityMemberAvartar16",
    "communityMemberAvartar17",
    "communityMemberAvartar18",
    "communityMemberAvartar19",
    "communityMemberAvartar20",
    "communityMemberAvartar21",
    "communityMemberAvartar22",
    "communityMemberAvartar23",
    "communityMemberAvartar24",
    "communityMemberAvartar25",
    "communityMemberAvartar26",
    "communityMemberAvartar27",
    "communityMemberAvartar28",
    "communityMemberAvartar29",
    "communityMemberAvartar30",
    "communityMemberAvartar31",
    "appWindowButton"
  ],

  communityMemberAvartar: ["communityMemberAvartar"],
  communityMemberAvartar2: ["communityMemberAvartar2"],
  communityMemberAvartar3: ["communityMemberAvartar3"],
  communityMemberAvartar4: ["communityMemberAvartar4"],
  communityMemberAvartar5: ["communityMemberAvartar5"],
  communityMemberAvartar6: ["communityMemberAvartar6"],
  communityMemberAvartar7: ["communityMemberAvartar7"],
  communityMemberAvartar8: ["communityMemberAvartar8"],
  communityMemberAvartar9: ["communityMemberAvartar9"],
  communityMemberAvartar10: ["communityMemberAvartar10"],
  communityMemberAvartar11: ["communityMemberAvartar11"],
  communityMemberAvartar12: ["communityMemberAvartar12"],
  communityMemberAvartar13: ["communityMemberAvartar13"],
  communityMemberAvartar14: ["communityMemberAvartar14"],
  communityMemberAvartar15: ["communityMemberAvartar15"],
  communityMemberAvartar16: ["communityMemberAvartar16"],
  communityMemberAvartar17: ["communityMemberAvartar17"],
  communityMemberAvartar18: ["communityMemberAvartar18"],
  communityMemberAvartar19: ["communityMemberAvartar19"],
  communityMemberAvartar20: ["communityMemberAvartar20"],
  communityMemberAvartar21: ["communityMemberAvartar21"],
  communityMemberAvartar22: ["communityMemberAvartar22"],
  communityMemberAvartar23: ["communityMemberAvartar23"],
  communityMemberAvartar24: ["communityMemberAvartar24"],
  communityMemberAvartar25: ["communityMemberAvartar25"],
  communityMemberAvartar26: ["communityMemberAvartar26"],
  communityMemberAvartar27: ["communityMemberAvartar27"],
  communityMemberAvartar28: ["communityMemberAvartar28"],
  communityMemberAvartar29: ["communityMemberAvartar29"],
  communityMemberAvartar30: ["communityMemberAvartar30"],
  communityMemberAvartar31: ["communityMemberAvartar31"],
  appWindowButton: ["appWindowButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebHomepage__ArgProps,
          internalVariantPropNames: PlasmicOp1WebHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOp1WebHomepage";
  } else {
    func.displayName = `PlasmicOp1WebHomepage.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicOp1WebHomepage = Object.assign(
  // Top-level PlasmicOp1WebHomepage renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    workspaceContentWrapper: makeNodeComponent("workspaceContentWrapper"),
    frame530: makeNodeComponent("frame530"),
    communityMemberAvartar: makeNodeComponent("communityMemberAvartar"),
    communityMemberAvartar2: makeNodeComponent("communityMemberAvartar2"),
    communityMemberAvartar3: makeNodeComponent("communityMemberAvartar3"),
    communityMemberAvartar4: makeNodeComponent("communityMemberAvartar4"),
    communityMemberAvartar5: makeNodeComponent("communityMemberAvartar5"),
    communityMemberAvartar6: makeNodeComponent("communityMemberAvartar6"),
    communityMemberAvartar7: makeNodeComponent("communityMemberAvartar7"),
    communityMemberAvartar8: makeNodeComponent("communityMemberAvartar8"),
    communityMemberAvartar9: makeNodeComponent("communityMemberAvartar9"),
    communityMemberAvartar10: makeNodeComponent("communityMemberAvartar10"),
    communityMemberAvartar11: makeNodeComponent("communityMemberAvartar11"),
    communityMemberAvartar12: makeNodeComponent("communityMemberAvartar12"),
    communityMemberAvartar13: makeNodeComponent("communityMemberAvartar13"),
    communityMemberAvartar14: makeNodeComponent("communityMemberAvartar14"),
    communityMemberAvartar15: makeNodeComponent("communityMemberAvartar15"),
    communityMemberAvartar16: makeNodeComponent("communityMemberAvartar16"),
    communityMemberAvartar17: makeNodeComponent("communityMemberAvartar17"),
    communityMemberAvartar18: makeNodeComponent("communityMemberAvartar18"),
    communityMemberAvartar19: makeNodeComponent("communityMemberAvartar19"),
    communityMemberAvartar20: makeNodeComponent("communityMemberAvartar20"),
    communityMemberAvartar21: makeNodeComponent("communityMemberAvartar21"),
    communityMemberAvartar22: makeNodeComponent("communityMemberAvartar22"),
    communityMemberAvartar23: makeNodeComponent("communityMemberAvartar23"),
    communityMemberAvartar24: makeNodeComponent("communityMemberAvartar24"),
    communityMemberAvartar25: makeNodeComponent("communityMemberAvartar25"),
    communityMemberAvartar26: makeNodeComponent("communityMemberAvartar26"),
    communityMemberAvartar27: makeNodeComponent("communityMemberAvartar27"),
    communityMemberAvartar28: makeNodeComponent("communityMemberAvartar28"),
    communityMemberAvartar29: makeNodeComponent("communityMemberAvartar29"),
    communityMemberAvartar30: makeNodeComponent("communityMemberAvartar30"),
    communityMemberAvartar31: makeNodeComponent("communityMemberAvartar31"),
    appWindowButton: makeNodeComponent("appWindowButton"),
    // Metadata about props expected for PlasmicOp1WebHomepage
    internalVariantProps: PlasmicOp1WebHomepage__VariantProps,
    internalArgProps: PlasmicOp1WebHomepage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/community",
      pagePath: "/community",
      params: {},
      query: {}
    })
  }
);

export default PlasmicOp1WebHomepage;
/* prettier-ignore-end */
